var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "site no-flex fit-content",
      class: {
        layout: _vm.Modernizr.flexbox,
        vertical: _vm.Modernizr.flexbox,
        fit: _vm.Modernizr.flexbox
      }
    },
    [
      _vm.loaded
        ? _c(
            "header",
            { staticClass: "full-width" },
            [_c("ii-header"), _vm._v(" "), _c("ii-navigation")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "self-stretch flex-auto layout vertical full-width" },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "loader-start" },
                [_c("loader", { attrs: { color: "white" } })],
                1
              )
            : _c("router-view", {
                key: _vm.$route.fullPath,
                staticClass: "container flex-1"
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.loaded ? _c("ii-footer") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64b7933d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b7933d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/App.vue
// module id = i8zr
// module chunks = 1